import { escapeHtml } from '../escape.js';
import { editAttr, itemCollection, itemStr, labeledIntro, list, sectionOpen, str } from './helpers.js';
import type { PatternSectionT } from '../../schema/index.js';

/** process — ordered steps or timeline entries. */
export function renderProcess(section: PatternSectionT): string {
  const heading = str(section.fields, 'heading');
  const label = str(section.fields, 'label');
  const steps = list(section.fields, 'steps')
    .map((item, index) => {
      const title = itemStr(item, 'title');
      const description = itemStr(item, 'description');
      if (!title && !description) return '';
      const stepPath = `/steps/${index}`;
      const lines = [`    <li class="ve-process__step"${editAttr(section, stepPath)}>`];
      if (section.variant === 'numbered_steps') {
        lines.push(`      <span class="ve-process__number">${escapeHtml(String(index + 1))}</span>`);
      }
      if (title) lines.push(`      <h3 class="ve-process__title">${escapeHtml(title)}</h3>`);
      if (description) lines.push(`      <p class="ve-process__description">${escapeHtml(description)}</p>`);
      lines.push('    </li>');
      return lines.join('\n');
    })
    .filter(Boolean)
    .join('\n');

  const parts: string[] = [
    sectionOpen(section),
    ...labeledIntro(section, 'process', heading, label),
    itemCollection(section, 'ol', 've-process__steps', '/steps', steps),
    '</section>',
  ];
  return parts.join('\n');
}
